import axios from "axios";

const BASE = "";

const api = axios.create({
  baseURL: `${BASE}/api/dreams`,
  withCredentials: true,
});

// Reaproveita o token JWT da auth principal (interceptor global guarda-o no localStorage)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ihtp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const viewAs = sessionStorage.getItem("ihtp_view_as");
  if (viewAs) config.headers["X-View-As"] = viewAs;
  return config;
});

export default api;
